<template>
<div>
    <!-- modal -->
    <b-modal id="serviceTypeFormModal" centered size="xl" no-close-on-backdrop ref="serviceTypeFormModal" :title=" $t('serviceType.info')" @close="clear()" hide-footer>
        <div class="custom-search d-flex justify-content-end">
            <b-row>
                <b-col>
                    <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                        {{$t('others.ok_title')}}
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="service-type-department-input">{{ $t('serviceType.department') }}</label>
                        <b-form-group>
                            <validation-provider :name=" $t('serviceType.department')" :rules="{ excluded:0}" v-slot="{ errors }">
                                <b-form-select :state="errors.length > 0 ? false:null" v-model="departmentSelect" value-field="id" text-field="name" size="sm" :options="departmentOption" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="service-type-module-input">{{ $t('serviceType.module') }}</label>
                        <b-form-group>
                            <validation-provider :name=" $t('serviceType.module')" :rules="{ excluded:0}" v-slot="{ errors }">
                                <b-form-select :state="errors.length > 0 ? false:null" v-model="moduleSelect" value-field="id" text-field="name" size="sm" :options="moduleOption" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="service-type-name-input">{{ $t('serviceType.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('serviceType.name')" rules="required">
                                <b-form-input id="service-type-name-input" v-model="serviceTypeName" maxlength="100" size="sm" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="service-type-sequence-no-input">{{ $t('serviceType.sequence_no') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('serviceType.sequence_no')" rules="required">
                                <b-form-input id="service-type-sequence-no-input" v-model="sequenceNo" type="number" size="sm" maxlength="10" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title=" $t('serviceType.invoice_templates')" active style="width:100%;">
                            <b-card-text>
                                <service-type-invoice-header-list :getServiceTypeInvoiceHeaderList="getServiceTypeInvoiceHeaderList" :serviceTypeId="this.id"></service-type-invoice-header-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>                            
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getServiceTypeList: {
            type: Function
        },
        getServiceTypeInvoiceHeaderList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            serviceTypeName: '',
            moduleSelect: 0,
            moduleOption: [],
            departmentSelect: 0,
            departmentOption: [],            
            hiddenControl: true,
            sequenceNo: 0,

        }
    },
    methods: {
        clear() {
            this.departmentSelect = 0
            this.moduleSelect = 0
            this.serviceTypeName = ''
        },
        showInfo(id) {
            this.$refs['serviceTypeFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'ServiceType'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    if (response.data.serviceType.id > 0) {
                        this.hiddenControl = false
                    } else {
                        this.hiddenControl = true
                    }
                    this.serviceTypeName = response.data.serviceType.name
                    this.sequenceNo = response.data.serviceType.sequenceNo
                    this.moduleOption = response.data.moduleList
                    this.moduleSelect = response.data.serviceType.moduleId
                    this.moduleOption.splice(0, 0, this.$nullSelected())

                    this.departmentOption = response.data.departmentList
                    this.departmentSelect = response.data.serviceType.departmentId
                    this.departmentOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('serviceTypeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.serviceTypeName,
                moduleId: this.moduleSelect,
                departmentId: this.departmentSelect,
                sequenceNo: this.sequenceNo,
            }
            const controller = {
                name: 'ServiceType'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.getServiceTypeList()
                            if (this.id == 0) {
                                this.id = response.data.serviceTypeId
                                this.hiddenControl = false
                            }
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })

                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
